// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__U9W6L","form":"Welcome_form__Aumfm","field":"Welcome_field__0Cfuk","error":"Welcome_error__IG697"};